import { IconButton } from '@material-ui/core'
import { Close as CloseIcon } from '@material-ui/icons'
import { graphql } from 'gatsby'
import { SnackbarAction, SnackbarKey } from 'notistack'
import React, { FC, MouseEvent, useCallback } from 'react'
import styled from 'styled-components'

export interface BlockedUserToastActionsProps {
  snackbarKey: SnackbarKey
  dismissToast: () => void
}

const CloseButton = styled(IconButton)`
  margin-left: 10px;

  &.MuiIconButton-root:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
`

export const getAuthBlockedUserToastActions = (
  props: Omit<BlockedUserToastActionsProps, 'snackbarKey'>,
): SnackbarAction => {
  const Actions = (snackbarKey: SnackbarKey) => {
    return <BlockedUserToastActions snackbarKey={snackbarKey} {...props} />
  }
  return Actions
}

export const BlockedUserToastActions: FC<BlockedUserToastActionsProps> = ({ dismissToast }) => {
  const onClickClose = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      event.preventDefault()
      event.stopPropagation()
      dismissToast()
    },
    [dismissToast],
  )

  return (
    <CloseButton
      data-cy="blocked-user-toast-close"
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClickClose}
    >
      <CloseIcon fontSize="small" />
    </CloseButton>
  )
}

export const blockedUserErrorMessageFragment = graphql`
  fragment blockedUserErrorMessage on SanitySiteSettings {
    blockedUserErrorMessage
  }
`
